import { PureComponent } from "react";
import classnames from "classnames";
import SignupFormComponent from "components/core/signups/base-signup-form/signup-form-component";
import PictureComponent from "/components/core/picture/picture-component";

import { StyledHeaderWithImageAndTitleComponent } from "./header-with-image-and-title-component.scss";
import colors from "/styles/colors";

export default class HeaderWithImageAndTitleComponent extends PureComponent {
  render() {
    const {
      signupForm,
      backgroundColor,
      hotdog,
      title,
      subtitle,
      image,
      textColor,
      imageWidth,
      useTemplateButton
    } = this.props;
    return (
      <StyledHeaderWithImageAndTitleComponent imageWidth={imageWidth} hotDogColor={backgroundColor} className="header-with-image-and-title-component">
        <div className="hot-dog" style={{ backgroundColor: colors[backgroundColor] }} />
        <div className={classnames("header-with-image-content", { "white-text": textColor === "white" })}>
          <h1 className="title" dangerouslySetInnerHTML={{ __html: title }} />
          {subtitle && <h2 className="subtitle" dangerouslySetInnerHTML={{ __html: subtitle }} />}
          {signupForm && (
            <div className="signup-form">
              <SignupFormComponent focusOnLoad={true} />
            </div>
          )}
          <div className={classnames("main-image", { "with-shadow": image.shadow })}>
            <PictureComponent {...image} />
          </div>
        </div>
      </StyledHeaderWithImageAndTitleComponent>
    );
  }
}

HeaderWithImageAndTitleComponent.defaultProps = {
  backgroundColor: "brand-purple",
  image: {},
  title: "",
  subtitle: "",
  signupForm: true,
  textColor: "",
  imageWidth: "50%"
};
